import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["min", "now", "max", "label", "srOnly", "striped", "active", "colors", "labelPosition", "className", "style", "clsPrefix"],
    _excluded2 = ["isChild"],
    _excluded3 = ["label", "srOnly", "striped", "colors", "className", "style", "min", "max", "now", "active", "size", "labelPosition", "children", "clsPrefix"];

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.assign.js";
import classnames from 'classnames';
import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import NProgress from 'nprogress';
import { WebUI, prefix } from "../../wui-core/src/index";
var ROUND_PRECISION = 1000;
/**
 * 自定义验证children是<ProgressBar>的实例.
 * @props 实例后的propTypes
 * @propName 本身propTypes的属性名 即 children
 * @componentName 实例后的children名 期望是ProgressBar
 */

function onlyProgressBar(props, propName, componentName) {
  var children = props[propName];

  if (!children) {
    return null;
  }

  var error = null;
  React.Children.forEach(children, function (child) {
    if (error) {
      return;
    }

    if (child.type === ProgressBar) {
      // eslint-disable-line no-use-before-define
      return;
    }

    var childIdentifier = /*#__PURE__*/React.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
    error = new Error("Children of ".concat(componentName, " can contain only ProgressBar ") + "components. Found ".concat(childIdentifier, "."));
  });
  return error;
}

var propTypes = {
  /**
   *  最小数值
   */
  min: PropTypes.number,

  /**
   *  有效数值
   */
  now: PropTypes.number,

  /**
   *  最大数值
   */
  max: PropTypes.number,

  /**
   *  文字描述标签
   */
  label: PropTypes.node,

  /**
   *  文字描述标签显示
   */
  srOnly: PropTypes.bool,

  /**
   *  条纹样式
   */
  striped: PropTypes.bool,

  /**
   *  激活状态
   */
  active: PropTypes.bool,

  /**
   *  大小
   */
  size: PropTypes.oneOf(['xs', 'sm']),

  /**
   *  labelPosition
   */
  labelPosition: PropTypes.oneOf(['right', 'left', 'center']),

  /**
   *  子组件 必须是ProgressBar
   */
  children: onlyProgressBar,

  /**
   *  子组件 必须是ProgressBar
   */
  style: PropTypes.object,

  /**
   * @private
   */
  isChild: PropTypes.bool
};
var defaultProps = {
  min: 0,
  max: 100,
  active: false,
  isChild: false,
  srOnly: false,
  striped: false,
  labelPosition: 'center'
};
/**
 * 计算实际显示比例
 * @now 显示的总数值
 * @min 最小数值
 * @max 最大数值
 */

function getPercentage(now, min, max) {
  var percentage = (now - min) / (max - min) * 100;
  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

var ProgressBar = (_dec = WebUI({
  name: "bar",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(ProgressBar, _React$Component);

  var _super = _createSuper(ProgressBar);

  function ProgressBar(props) {
    var _this;

    _classCallCheck(this, ProgressBar);

    _this = _super.call(this, props);
    _this.state = {
      now: _this.props.now,
      max: _this.props.max,
      min: _this.props.min,
      active: _this.props.active
    };
    return _this;
  }

  _createClass(ProgressBar, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        now: nextProps.now,
        max: nextProps.max,
        min: nextProps.min,
        active: nextProps.active
      });
    }
  }, {
    key: "renderProgressBar",
    value: function renderProgressBar(_ref) {
      var min = _ref.min,
          now = _ref.now,
          max = _ref.max,
          label = _ref.label,
          srOnly = _ref.srOnly,
          striped = _ref.striped,
          active = _ref.active,
          colors = _ref.colors,
          labelPosition = _ref.labelPosition,
          className = _ref.className,
          style = _ref.style,
          clsPrefix = _ref.clsPrefix,
          others = _objectWithoutProperties(_ref, _excluded);

      var childClsPrefix = clsPrefix + '-bar';
      var classes = {
        active: active
      };

      if (active || striped) {
        classes["".concat(childClsPrefix, "-striped")] = true;
      }

      if (colors) {
        classes["".concat(childClsPrefix, "-").concat(colors)] = true;
      }

      var classNames = classnames(childClsPrefix, classes); //返回不敢wrapper的progressbar

      return /*#__PURE__*/React.createElement("div", _extends({}, others, {
        role: "progressbar",
        className: classnames(className, classNames),
        style: _objectSpread({
          width: "".concat(getPercentage(now, min, max), "%")
        }, style)
      }), /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-progress-label")
      }, srOnly ? /*#__PURE__*/React.createElement("span", {
        className: "sr-only"
      }, label) : label));
    }
  }, {
    key: "render",
    value: function render() {
      //先处理以组ProgressBar形式使用情况
      var _this$props = this.props,
          isChild = _this$props.isChild,
          props = _objectWithoutProperties(_this$props, _excluded2); // 判断isChild是否为true,如果是true,直接渲染成bar


      if (isChild) {
        return this.renderProgressBar(props);
      }

      var label = props.label,
          srOnly = props.srOnly,
          striped = props.striped,
          colors = props.colors,
          className = props.className,
          style = props.style,
          min = props.min,
          max = props.max,
          now = props.now,
          active = props.active,
          size = props.size,
          labelPosition = props.labelPosition,
          children = props.children,
          clsPrefix = props.clsPrefix,
          wrapperProps = _objectWithoutProperties(props, _excluded3);
      /**
       * 如果是单独直接用<ProgressBar /> 走children判断为false语句。
       * 如果以组的形式使用<ProgressBar><ProgressBar now={10} /><ProgressBar now={20}/></ProgressBar> 走判断语句为true，
       * 将children分别加上isChild=true的属性
       */


      return /*#__PURE__*/React.createElement("div", _extends({}, wrapperProps, {
        className: classnames(className, clsPrefix, size)
      }), children ? React.Children.map(children, function (child) {
        return /*#__PURE__*/cloneElement(child, {
          isChild: true
        });
      }) : this.renderProgressBar(_objectSpread({
        min: min,
        now: now,
        max: max,
        label: label,
        srOnly: srOnly,
        striped: striped,
        active: active,
        colors: colors,
        labelPosition: labelPosition,
        className: className,
        style: style,
        clsPrefix: clsPrefix
      }, wrapperProps)));
    }
  }]);

  return ProgressBar;
}(React.Component)) || _class);
ProgressBar.propTypes = propTypes;
Object.assign(ProgressBar, NProgress);
export default ProgressBar;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-progress/src/Bar.js